import { useNavigate, useParams } from "react-router-dom"
import { Helmet } from "react-helmet";
import MatrixAnimation from "../components/MatrixAnimation";
import AndroidRoadmap from "../assets/android.png"
import axios from "axios";
import FrontEnd from "../assets/frontend.webp"
import Hack from "../assets/hack.png"
import Backend from "../assets/backend.png"
import AI from "../assets/ai.png"
import { useRef, useState } from "react";


export const RoadMap = ()=>{
    const {slug} = useParams()
    const navigate = useNavigate();

    const isSlugValid =(slug)=>{
        if (slug == "mobile" || slug == "gamedevelopment" || slug == "frontend" || slug=="backend" || slug == "ai" || slug=="security"){
            return true;
        }
        return false;
    }

    if (!slug || !isSlugValid(slug)){
        navigate("/");
    }


    // const []
    
    return (
        <MatrixAnimation DotsColor = "100, 150, 100">
            {
                slug=="mobile"?<MobilePageContent></MobilePageContent>:""
            }
            {
                slug=="frontend"?<FrontendComponent></FrontendComponent>:""
            }
            {
                slug=="security"?<HackingRoadmap></HackingRoadmap>:""
            }
            {
                slug=="backend"?<BackendRoadmap></BackendRoadmap>:""
            }
            {
                slug=="ai"?<AiRoadmap></AiRoadmap>:""
            }
        </MatrixAnimation>
    )
}

const GetRoadMapComponent = ({roadMap})=>{
    const fullnameRef = useRef();
    const phoneNumber = useRef();
    const email = useRef();

    const [formNotification, setFormNotification] = useState({
        display:false,
        success:false,
        message: ""
    });
    const [requesting, setIsRequesting] = useState(false);

    const getRoadMapRequest=()=>{

        if (requesting){
            return false;
        }
        if (!fullnameRef.current.value || !phoneNumber.current.value || !email.current.value){
            setFormNotification({
                display:true,
                success:false,
                message: "لطفا تمامی اطلاعات مورد نیار را وارد نمایید"
            })

            return false;
        }

        if (phoneNumber.current.value[0] != "0" || phoneNumber.current.value[1] != "9" || phoneNumber.current.value.length != 11){
            setFormNotification({
                display:true,
                success:false,
                message: " شماره تماس صحیح نمیباشد ، شماره تماس باید 11 رقم باشد و با 09 آغاز شود"
            })

            return false;
        }

        if (!email.current.value || !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email.current.value)) {
            setFormNotification({
                display: true,
                success: false,
                message: "آدرس ایمیل به درستی وارد نشده است"
            });
        
            return false;
        }
        

        setIsRequesting(true);
        const form = new FormData();
        form.append("fullname", fullnameRef.current.value);
        form.append("email", email.current.value);
        form.append("phone", phoneNumber.current.value);
        form.append("roadmap", roadMap)

        axios.post(`https://hivoo.ir/assets/api/getroadmap/`, form).then((res)=>{
            setIsRequesting(false);
            if (res.data.status == "success"){
                setFormNotification({
                    display:true,
                    success:true,
                    message: "نقشه راه با موفقیت به ایمیل شما ارسال شد"
                })
                email.current.value = '';
                fullnameRef.current.value = '';
                phoneNumber.current.value = ''
            }else if (res.data.status == "phone_exist_today"){
                setFormNotification({
                    display:true,
                    success:false,
                    message: "یکبار نقشه راه با این شماره تماس در 24 ساعت گذشته ارسال شده است"
                })
            }else if (res.data.status == "email_exist_today"){
                setFormNotification({
                    display:true,
                    success:false,
                    message: "یکبار نقشه راه به این ایمیل در 24 ساعت گذشته ارسال شده است"
                })
            }
        })
    }

    return (
        <div className="w-11/12 flex items-center flex-col bg-hivoo-light mx-auto rounded-3xl">
            <div className="w-[95%] flex flex-col items-end text-white font-main justify-end">
                <span className="text-2xl my-4 font-bold">
                    دریافت رایگان نقشه راه
                </span>
                <p className="font-light text-gray-400 text-right">
                    جهت دریافت نقشه راه کاملا تخصصی و کارشناسی تنها کافی است اطلاعات زیر را تکمیل کنید
                </p>
            </div>
            <div className="flex flex-col lg:flex-row-reverse w-[95%] gap-10 my-4 font-main">
                <div className="w-full flex flex-col">
                    <label className="w-[99%] text-right text-white my-3">نام و نام خانوادگی</label>
                    <input ref = {fullnameRef} type = "text" className="w-full px-2 py-5 rounded-xl bg-hivoo border border-gray-300 outline-none border-opacity-15 text-right transition-all text-white focus:border-cyan-600" placeholder="نام و نام خانوادگی خود را وارد کنید"/>
                </div>
                
                <div className="w-full flex flex-col">
                    <label className="w-[99%] text-right text-white my-3">شماره تماس</label>
                    <input ref = {phoneNumber} type = "text" className="w-full px-2 py-5 rounded-xl bg-hivoo border text-white border-gray-300 outline-none border-opacity-15 text-right transition-all focus:border-cyan-600" placeholder="شماره تماس خود را وارد کنید"/>
                </div>

                <div className="w-full flex flex-col">
                    <label className="w-[99%] text-right text-white my-3">ایمیل</label>
                    <input ref = {email} type = "text" className="w-full px-2 py-5 rounded-xl bg-hivoo border text-white border-gray-300 outline-none border-opacity-15 text-right transition-all focus:border-cyan-600" placeholder="ایمیل خود را وارد کنید"/>
                </div>
            </div>
            <div className="w-11/12 my-5 flex items-center justify-center lg:justify-start">
                <button onClick={getRoadMapRequest} className="bg-blue-600 text-white font-main py-3 px-10 rounded-xl transition-all hover:bg-blue-800">
                    دریافت نقشه راه
                </button>
            </div>
            {
                formNotification.display==true?<span className={`w-11/12 rounded-xl py-3  bg-opacity-25 text-center my-3  font-main ${formNotification.success==false?"bg-red-900 text-red-400":"bg-green-900 text-green-400"}`}>
                {formNotification.message}
            </span> : ""
            }
            
        </div>
    )
}


const MobilePageContent = ()=>{
    return (
        <>
            <Helmet>
                <title>نقشه راه برنامه‌نویسی موبایل | آموزش جامع برای شروع و حرفه‌ای شدن
                </title>
                <meta name="description" content="اگر قصد دارید برنامه‌نویسی موبایل را از پایه شروع کنید و به یک متخصص حرفه‌ای تبدیل شوید، این نقشه راه گام‌به‌گام بهترین راهنمای شماست. با ما همراه باشید!" />
            </Helmet>
            <div className="w-full flex flex-col-reverse lg:flex-row min-h-[50vh] my-10">
            <div className="w-full lg:w-2/4 flex flex-col justify-center items-center lg:items-end text-center lg:text-right font-main text-white">
            <h1 className="text-4xl w-3/4 font-black leading-relaxed">
            نقشه راه برنامه‌نویسی موبایل: راهنمای کامل برای مبتدیان و حرفه‌ای‌ها
            </h1>
            <p className="w-3/4 text-center lg:text-right font-light text-gray-300 mt-10 text-sm lg:text-normal leading-[40px]">
            نقشه راه برنامه‌نویسی موبایل، بهترین راهنمای شما برای ورود به دنیای ساخت اپلیکیشن‌های حرفه‌ای است. با یادگیری اصول اولیه، انتخاب زبان مناسب مثل Swift، Kotlin یا فریم‌ورک‌های پرکاربردی مانند Flutter و React Native، می‌توانید مسیر خود را برای تبدیل‌شدن به یک برنامه‌نویس موفق آغاز کنید. در این راهنما، گام‌به‌گام تمامی مراحل موردنیاز، ابزارهای ضروری و منابع آموزشی معرفی شده‌اند تا بتوانید بدون سردرگمی وارد دنیای جذاب توسعه موبایل شوید.
            </p>
            </div>
            <div className="w-full lg:w-2/4 flex items-center justify-center lg:justify-start">
                <img src = {AndroidRoadmap} alt = "نقشه راه اندروید" className="w-2/4"></img>
            </div>
        </div>

        <GetRoadMapComponent roadMap = {4}></GetRoadMapComponent>
        </>
       
    )
}


const FrontendComponent = ()=>{
    return (
        <>
            <Helmet>
                <title>نقشه راه فرانت اند | آموزش جامع برای شروع و حرفه‌ای شدن
                </title>
                <meta name="description" content="فرانت اند یکی از مهمترین شاخه های برنامه نویسی وب میباشد ، میتوانید از اینجا نقشه راه فرانت اند را دریافت کنید" />
            </Helmet>
            <div className="w-full flex flex-col-reverse lg:flex-row min-h-[50vh] my-10">
            <div className="w-full lg:w-2/4 flex flex-col justify-center items-center lg:items-end text-center lg:text-right font-main text-white">
            <h1 className="text-4xl w-3/4 font-black leading-relaxed">
                نقشه راه فرانت اند | مسیر صفر تا صد فرانت اند
            </h1>
            <p className="w-3/4 text-center lg:text-right font-light text-gray-300 mt-10 text-sm lg:text-normal leading-[40px]">
            اگر به طراحی وبسایت‌ها و رابط‌های کاربری جذاب علاقه دارید، مسیر یادگیری فرانت‌اند می‌تواند شما را به یک متخصص حرفه‌ای تبدیل کند. در این نقشه راه، از مبانی اولیه HTML، CSS و JavaScript شروع می‌کنید و به سمت تکنولوژی‌های پیشرفته‌تری مثل React، Vue.js و ابزارهایی نظیر Webpack و Tailwind CSS پیش می‌روید. همچنین یاد می‌گیرید چطور طراحی‌های ریسپانسیو و سازگار با دستگاه‌های مختلف بسازید و از بهترین روش‌ها برای بهینه‌سازی عملکرد سایت‌ها استفاده کنید. این مسیر نه‌تنها مهارت‌های فنی شما را تقویت می‌کند، بلکه شما را برای ورود به بازار کار آماده می‌سازد. فرانت‌اند یک دنیای خلاقانه است که هر روز فرصت‌های جدیدی برای یادگیری و رشد ارائه می‌دهد!
            </p>
            </div>
            <div className="w-full lg:w-2/4 flex items-center justify-center lg:justify-start">
                <img src = {FrontEnd} alt = "نقشه فرانت اند" className="w-2/4"></img>
            </div>
        </div>

        <GetRoadMapComponent roadMap = {1}></GetRoadMapComponent>
        
        </>
       
    )
}

const HackingRoadmap = ()=>{
    return (
        <>
            <Helmet>
                <title>نقشه راه هک و امنیت | آموزش جامع برای شروع و حرفه‌ای شدن
                </title>
                <meta name="description" content="فرانت اند یکی از مهمترین شاخه های برنامه نویسی وب میباشد ، میتوانید از اینجا نقشه راه فرانت اند را دریافت کنید" />
            </Helmet>
            <div className="w-full flex flex-col-reverse lg:flex-row min-h-[50vh] my-10">
            <div className="w-full lg:w-2/4 flex flex-col justify-center items-center lg:items-end text-center lg:text-right font-main text-white">
            <h1 className="text-4xl w-3/4 font-black leading-relaxed">
            نقشه راه هک و امنیت: ورود به دنیای امنیت سایبری
            </h1>
            <p className="w-3/4 text-center lg:text-right font-light text-gray-300 mt-10 text-sm lg:text-normal leading-[40px]">
            در دنیای امروز، امنیت سایبری به یکی از حیاتی‌ترین حوزه‌های فناوری تبدیل شده است. نقشه راه هک و امنیت مسیری روشن برای یادگیری مفاهیم پایه امنیت اطلاعات، زبان‌های برنامه‌نویسی مرتبط، و ابزارهای تست نفوذ ارائه می‌دهد. این مسیر شما را با تکنیک‌های پیشرفته‌ای مانند حملات سایبری، تحلیل شبکه، رمزنگاری، و تست نفوذ آشنا می‌کند و مهارت‌هایی به شما می‌آموزد که برای شناسایی و رفع آسیب‌پذیری‌های سیستم‌ها ضروری هستند. با یادگیری این مهارت‌ها و ابزارهای روز دنیا، می‌توانید به یکی از متخصصان برتر در این حوزه تبدیل شوید و در حفاظت از دنیای دیجیتال نقش مهمی ایفا کنید.
            </p>
            </div>
            <div className="w-full lg:w-2/4 flex items-center justify-center lg:justify-start">
                <img src = {Hack} alt = "نقشه هک و امنیت" className="w-2/4"></img>
            </div>
        </div>

        <GetRoadMapComponent roadMap = {7}></GetRoadMapComponent>
        
        </>
       
    )
}

const BackendRoadmap = ()=>{
    return (
        <>
            <Helmet>
                <title>نقشه راه هک و امنیت | آموزش جامع برای شروع و حرفه‌ای شدن
                </title>
                <meta name="description" content="فرانت اند یکی از مهمترین شاخه های برنامه نویسی وب میباشد ، میتوانید از اینجا نقشه راه فرانت اند را دریافت کنید" />
            </Helmet>
            <div className="w-full flex flex-col-reverse lg:flex-row min-h-[50vh] my-10">
            <div className="w-full lg:w-2/4 flex flex-col justify-center items-center lg:items-end text-center lg:text-right font-main text-white">
            <h1 className="text-4xl w-3/4 font-black leading-relaxed">
            نقشه راه بک‌اند: ساختار پشت‌پرده دنیای وب
            </h1>
            <p className="w-3/4 text-center lg:text-right font-light text-gray-300 mt-10 text-sm lg:text-normal leading-[40px]">
            بک‌اند قلب تپنده هر وب‌سایت و اپلیکیشن است. در این نقشه راه، شما با زبان‌های برنامه‌نویسی قدرتمند مانند PHP، Python، Java و فریم‌ورک‌های پیشرفته مثل Laravel و Django آشنا می‌شوید. همچنین مفاهیم پایه‌ای مانند مدیریت پایگاه داده، REST API، احراز هویت و امنیت و معماری سرور را یاد می‌گیرید. این مسیر به شما کمک می‌کند تا سیستم‌هایی پایدار، امن و مقیاس‌پذیر بسازید و زیرساختی قوی برای خدمات آنلاین فراهم کنید. اگر به دنبال یادگیری مهارتی هستید که در بازار کار تقاضای بالایی داشته باشد، مسیر بک‌اند بهترین انتخاب برای شماست.
            </p>
            </div>
            <div className="w-full lg:w-2/4 flex items-center justify-center lg:justify-start">
                <img src = {Backend} alt = "نقشه بک اند" className="w-2/4"></img>
            </div>
        </div>

        <GetRoadMapComponent roadMap = {2}></GetRoadMapComponent>
        
        </>
       
    )
}

const AiRoadmap = ()=>{
    return (
        <>
            <Helmet>
                <title>نقشه راه هک و امنیت | آموزش جامع برای شروع و حرفه‌ای شدن
                </title>
                <meta name="description" content="فرانت اند یکی از مهمترین شاخه های برنامه نویسی وب میباشد ، میتوانید از اینجا نقشه راه فرانت اند را دریافت کنید" />
            </Helmet>
            <div className="w-full flex flex-col-reverse lg:flex-row min-h-[50vh] my-10">
            <div className="w-full lg:w-2/4 flex flex-col justify-center items-center lg:items-end text-center lg:text-right font-main text-white">
            <h1 className="text-4xl w-3/4 font-black leading-relaxed">
            نقشه راه هوش مصنوعی: آغاز سفری به آینده فناوری
            </h1>
            <p className="w-3/4 text-center lg:text-right font-light text-gray-300 mt-10 text-sm lg:text-normal leading-[40px]">
            هوش مصنوعی یکی از پیشرفته‌ترین و جذاب‌ترین حوزه‌های فناوری است که آینده را شکل می‌دهد. در این نقشه راه، شما با مبانی یادگیری ماشین، یادگیری عمیق، و مفاهیمی مثل شبکه‌های عصبی آشنا می‌شوید. ابزارها و زبان‌هایی مانند Python، کتابخانه‌هایی نظیر TensorFlow و PyTorch، و کار با داده‌ها از جمله مهارت‌های کلیدی در این مسیر هستند. همچنین یادگیری روش‌های پیشرفته مثل پردازش زبان طبیعی (NLP)، بینایی کامپیوتر (Computer Vision) و پیاده‌سازی مدل‌های هوشمند در دنیای واقعی به شما کمک می‌کند تا سیستم‌هایی طراحی کنید که توانایی یادگیری، تحلیل و تصمیم‌گیری داشته باشند. با دنبال کردن این مسیر، می‌توانید بخشی از تحول عظیم در دنیای فناوری شوید و آینده‌ای درخشان برای خود رقم بزنید.
            </p>
            </div>
            <div className="w-full lg:w-2/4 flex items-center justify-center lg:justify-start">
                <img src = {AI} alt = "نقشه هوش مصنوعی" className="w-2/4"></img>
            </div>
        </div>
        <GetRoadMapComponent roadMap = {3}></GetRoadMapComponent>
        </>
       
    )
}